import { useState } from "react";
import orgApi from "@/lib/orgApi";
import { getErrorMessage } from "@/lib/api";
import { SettingsRow } from "./SettingsSection";

const button = "inline-flex items-center justify-center rounded-full border border-[var(--studio-divider)] px-4 py-2.5 font-sans text-sm text-[var(--text-primary)] transition-colors duration-200 hover:bg-[var(--studio-overlay)] active:scale-95 disabled:opacity-50";

export default function SchedulerIdentityLink({ onLinked }) {
  const [profiles, setProfiles] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [needsLogin, setNeedsLogin] = useState(false);
  const [linked, setLinked] = useState(false);
  async function review() {
    setBusy(true); setError(""); setNeedsLogin(false); setProfiles(null);
    try { const { data } = await orgApi.get("/org/scheduler/identity-link"); setProfiles(data); }
    catch (err) {
      setNeedsLogin(err.response?.data?.detail?.code === "personal_login_required");
      setError(getErrorMessage(err, "Could not review your profiles. Please try again."));
    } finally { setBusy(false); }
  }
  async function link() {
    setBusy(true); setError("");
    try {
      await orgApi.post("/org/scheduler/identity-link", {
        personal_user_id: profiles.personal_user_id, organization_admin_id: profiles.organization_admin_id,
        email: profiles.email, confirm: true,
      });
      setLinked(true); setProfiles(null); onLinked?.();
    } catch (err) {
      setProfiles(null);
      setError(getErrorMessage(err, "Could not link your profiles. Review them and try again."));
    } finally { setBusy(false); }
  }
  return <SettingsRow title="Personal and organization scheduling" desc="Use one Scheduler account for your personal studio and the organizations you administer. Sign into both Hans profiles with the same verified email to link them.">
    {linked ? <p role="status" className="mt-3 text-sm text-[var(--text-secondary)]">Your profiles are linked. Finish any pending scheduling setup, then use the business selector in Scheduler.</p> : <div className="mt-4 space-y-3">
      {profiles && <div className="space-y-2 text-sm text-[var(--text-secondary)]">
        <p>Personal profile: {profiles.personal_name}</p>
        <p>Administrator profile: {profiles.organization_name}</p>
        <p>{profiles.email}</p>
        <p>Linking shares your Scheduler login. Each business keeps its own permissions and calendar.</p>
      </div>}
      <div className="flex flex-wrap gap-2">
        {needsLogin && <a className={button} href="/login" target="_blank" rel="noopener noreferrer">Sign into personal Hans</a>}
        <button type="button" className={button} disabled={busy} onClick={profiles ? link : review}>{busy ? "Please wait…" : profiles ? "Link these profiles" : "Review profiles to link"}</button>
        {profiles && <button type="button" className={button} disabled={busy} onClick={() => setProfiles(null)}>Cancel</button>}
      </div>
    </div>}
    {error && <p role="alert" className="mt-3 text-sm text-[var(--state-danger)]">{error}</p>}
  </SettingsRow>;
}
